export const HomePageRoute = '/';

export const ContactPageRoute = '/contact';
export const ShopPageRoute = '/shop';
export const ProfilePageRoute = '/profile';
export const ArticlePageRoute = '/articles/:articleId';

export const FavouritesPageRoute = '/Favourites';
export const CartPageRoute = '/Cart';
export const CatalogPageRoute = '/Catalog';
export const HistoryOfOrdersPageRoute = '/HistoryOfOrders';
export const DeliveryOrderPageRoute = '/DeliveryOrder';
export const CreatingUserFizicheskoyeLitsoPageRoute = '/CreatingUserFizicheskoyeLitso';
export const CreatingUserYuridicheskoyeLitsoPageRoute = '/CreatingUserYuridicheskoyeLitso';

export const CrmPageRoute = '/Crm';
export const OrdersPageRoute = '/orders';
export const OrderPagePageRoute = '/orders/:id';
export const InvoicePageRoute = '/orders/:id/Invoice';
export const ClientsListPageRoute = '/ClientsList';
export const ClientDetailsPageRoute = '/ClientsList/ClientDetails/:id';
export const AddClientModalPageRoute = '/ClientsList/AddClientModal';
export const DriversComponentPageRoute = '/DriversComponent';
export const VehiclesPageRoute = '/Vehicles';
export const ChatPageRoute = '/Chat';
export const SettingsPageRoute = '/settings';
export const CreateContractPageRoute = '/CreateContract';
export const ContractDetailsPageRoute = '/ClientsList/ClientDetails/ContractDetails/:id';
export const ProductionPageRoute = '/Production';
export const ApplicationsPageRoute = '/Applications';
export const LogisticsPageRoute = '/Logistics';
export const ArchiveOrdersPageRoute = '/ArchiveOrders';
export const WaybillPageRoute = '/Waybill';
export const TrackSheetPageRoute = '/TrackSheet';
export const LostOrdersPageRoute = '/LostOrders';
export const OrdersOnDeliveryPageRoute = '/OrdersOnDelivery';
export const WeeklyOrdersPageRoute = '/WeeklyOrders';
export const ApplyPageRoute = '/Apply';
export const MyOrdersPageRoute = '/MyOrders';
export const MyContractsPageRoute = '/MyContracts/:id';
export const OrganizationDetailsPageRoute = '/OrganizationDetails';
export const PaymentStatusPageRoute = '/PaymentStatus';

export const AdminPanelPageRoute = '/AdminPanel';
export const CreateUserPagePageRoute = '/CreateUserPage';
export const CreateProductPagePageRoute = '/CreateProductPage';
export const UserListPageRoute = '/UserList';
export const UserProfilePageRoute = '/userprofile/:id';
export const ProductListPageRoute = '/ProductList';
export const ProductProfilePageRoute = '/productprofile/:id';
export const TransportListPageRoute = '/TransportList';
export const TransportProfilePageRoute = '/TransportProfile/:id';
export const CreateTransportPageRoute = '/CreateTransportPage';
export const AdminClientsListPageRoute = '/Admin/Clients';
export const CreateContractAdminPageRoute = '/Admin/CreateContract';
export const ContractsListAdminPageRoute = '/Admin/Contracts';
export const DeliveryAreasComponentPageRoute = '/DeliveryAreasComponent';
export const CreateClientAdminPageRoute = '/Admin/Clients/Create';
export const EditClientAdminPageRoute = '/Admin/Clients/:id/edit';

// Справочники
export const OrganizationsListPageRoute = '/Admin/Organizations';
export const DivisionsListPageRoute = '/Admin/Divisions';
export const RegionsListPageRoute = '/Admin/Regions';
export const DriversListPageRoute = '/Admin/Drivers';
